<template></template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'live-packages',

  computed: {
    ...mapGetters({
      activeProperties: 'property/activeProperties',
      lotPriceRanges: 'filter/priceRanges',
      lotSizeRanges: 'filter/lotSizeRanges',
      dwellingSizeRanges: 'filter/dwellingSizeRanges'
    })
  },

  created () {
    this.setFilterRanges()
  },

  methods: {
    setFilterRanges () {
      this.$store.commit('filter/SET_FILTER_PARAMETERS', {
        inputPriceRange: this.lotPriceRanges,
        inputLotSizeRange: this.lotSizeRanges,
        inputDwellingSizeRange: this.dwellingSizeRanges,
        inputBeds: false,
        inputBaths: false,
        inputCars: false,
        inputLotNumber: '',
        inputBuilder: ''
      })
    },
  }
}
</script>
